import React from 'react'

import { useAppSelector } from '../../../../../hooks/redux'
import { selectBaseInbox } from '../../../../../slices/baseInbox'
import { selectViews } from '../../../../../slices/views'
import { selectConvo } from '../../../../../slices/convo'
import useStyles from './styles'

interface SimpleInboxProps {}

const SimpleInbox: React.FC<SimpleInboxProps> = () => {
  const { inboxes } = useAppSelector(selectBaseInbox)
  const { views } = useAppSelector(selectViews)
  const { inbox, view } = useAppSelector(selectConvo)

  const name = React.useMemo(() => {
    if (view) {
      const foundView = views.find(v => v.id === view)
      if (!foundView.hidden) {
        return foundView?.name ?? 'Unknown'
      }
    }

    const foundInbox = inboxes.find(i => i.id === inbox)
    return foundInbox?.name ?? 'Unknown'
  }, [view, views, inbox, inboxes])

  const classes = useStyles()

  return <div className={classes.root}>{name}</div>
}

export default SimpleInbox
